<template>
    <div>
        <form @submit.prevent="search()">
            <b-form-group :label="$t('findProduct')" label-class="p-0" class="width-max-400 mb-2">
                <div class="position-relative ml-0">
                    <b-form-input v-model="text" class="z-index-1" :placeholder="$t('nameEanNumberOrModel')" :disabled="rootLoading" />
                    <ButtonIcon
                        v-show="text"
                        icon="x"
                        size="sm"
                        variant="outline-light"
                        class="border-0 bg-white p-0 my-auto position-absolute z-index-2"
                        style="transform:translate(-50%,-50%); top:50%; right:0px;"
                        :disabled="requestProductsTreeSearch.getLoading() || rootLoading"
                        @click="reset()"
                    />
                </div>
                <h5 v-show="tree && !tree.length" class="my-3">{{ $t('noAvailableProducts') }}</h5>
            </b-form-group>
        </form>
        <Tree
            v-show="!tree || tree.length"
            ref="Tree"
            :options="tree"
            :load-options="loadOptions"
            :normalizer="normalizer"
            selectable
            v-on="$listeners"
            @rootLoading="rootLoading = $event"
        />
    </div>
</template>



<script>
    import debounce from 'lodash/debounce';
    import { recursiveMapByKey } from '@/utils/util';
    import Tree from '@/components/common/Tree.vue';

    export default {
        name: 'ProductsTree',
        components: {
            Tree,
        },
        data() {
            return {
                requestProductsTree: this.$req('space/ProductsTree'),
                requestProductsTreeSearch: this.$req('space/ProductsTreeSearch'),
                text: '',
                tree: null,
                rootLoading: false,
                searchDebounced: null,
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            loading() {
                return false;
            },
        },
        watch: {
            text(text) {
                if (text) {
                    this.loadOptions({ searchQuery: text });
                } else {
                    this.reset();
                }
            },
        },
        methods: {
            fetchProductsTreeSearchDebounced(searchQuery) {
                return new Promise((resolve, reject) => {
                    this.searchDebounced(searchQuery, resolve, reject);
                });
            },
            fetchProductsTreeSearch(searchQuery) {
                return this.requestProductsTreeSearch.get({ urlParams: { spaceId: this.spaceId }, requestParams: { search: searchQuery } }).then(data => {
                    if (searchQuery === this.text) {
                        this.tree = recursiveMapByKey(data || [], 'children', node => ({ ...node, children: node.items || false, isDefaultExpanded: true }));
                    } else if (!this.text) {
                        this.reset();
                    }
                });
            },
            fetchProductsTree(categoryId) {
                return this.requestProductsTree.id(categoryId || 'root').get({ urlParams: { spaceId: this.spaceId }, requestParams: { category: categoryId } });
            },
            loadOptions({ parentNode, searchQuery }) {
                if (searchQuery) {
                    return this.fetchProductsTreeSearchDebounced(searchQuery);
                }
                return this.fetchProductsTree(parentNode?.entityId);
            },
            normalizer(node) {
                return {
                    id: node.entityId,
                    label: node.text,
                    children: node.children === true ? null : node.children,
                    isDisabled: false,
                };
            },
            reset() {
                const isTree = !!this.tree;
                this.text = '';
                this.tree = null;
                if (isTree) this.$nextTick(() => this.$refs.Tree.$refs.FormSelectTree.$refs.TreeSelect.loadRootOptions());
            },
        },
        created() {
            this.fetchProductsTree();
            this.searchDebounced = debounce((searchQuery, resolve, reject) => {
                this.fetchProductsTreeSearch(searchQuery).then(resolve).catch(reject);
            }, 500);
        },
    };
</script>
